import { useEffect, useState } from "react";

import { ITicketCampaign } from "../types";

interface IProps {
  campaign: ITicketCampaign;
  onClose: () => void;
}

export function ThumbLightbox({ campaign, onClose }: IProps) {
  const [animate, setAnimate] = useState(false);

  function handleClose() {
    setAnimate(false);
    setTimeout(() => onClose(), 300);
  }

  useEffect(() => {
    setTimeout(() => setAnimate(true), 10);

    function handleEscapeClose() {
      setAnimate(false);
      setTimeout(() => onClose(), 300);
    }

    function handleEscape(evt: KeyboardEvent) {
      if (evt.key === "Escape" || evt.key === "Esc" || evt.keyCode === 27) {
        handleEscapeClose();
      }
    }

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [onClose]);

  return (
    <>
      <div
        className={`modal fade ${animate ? "show" : ""}`}
        style={{ display: "block" }}
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content bg-dark text-white">
            <div className="modal-header border-secondary">
              <div>
                <h5 className="modal-title fw-bold mb-0">{campaign.name}</h5>
                <small className="text-white-50">Thumb da campanha</small>
              </div>
              <button
                type="button"
                className="btn-close btn-close-white"
                aria-label="Fechar"
                onClick={handleClose}
              />
            </div>
            <div className="modal-body p-0">
              <img
                src={campaign.thumb}
                alt={campaign.name}
                className="w-100"
                style={{
                  maxHeight: "75vh",
                  objectFit: "contain",
                  background: "#111",
                }}
              />
            </div>
          </div>
        </div>
      </div>
      <div className={`modal-backdrop fade ${animate ? "show" : ""}`}></div>
    </>
  );
}
